import { nextTick } from "vue"
import './index.css'
import { _get, _getNull } from "@utils/utils";

let cache = [];

uni.addInterceptor('redirectTo', {
    success(args) {
        cache.splice(cache.length - 2, 1)
    },
});

const routeTransition = (vue) => {
    // #ifdef H5
    cache = JSON.parse(localStorage.getItem('routeCache') || '[]')
    const app = document.getElementById('app')
    const back = document.createElement('div')
    back.id = 'back'
    let mode = null
    document.body.appendChild(back)
    nextTick(() => {
        vue.router.beforeEach((to, from) => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
            // 刷新
            if (!from.href) {
                cache.length = 0
                if (!to.meta.isTabBar) {
                    cache.push({ path: to.path })
                }
                cache.push({ path: to.path })
                mode = null
            }
            // tabBar切换
            else if (to.meta.isTabBar && from.meta.isTabBar) {
                cache.splice(-1, 1, { path: to.path })
                mode = null
            }
            // 退出
            else if (_getNull(cache, `${cache.length - 2}.path`) === to.path) {
                cache.pop()
                mode = 'fade'
            }
            // 进入
            else {
                // @ts-ignore 缓存滚动条高度
                if (cache.length) cache[cache.length - 1].scrollTop = scrollTop
                cache.push({ path: to.path, scrollTop: 0 })
                mode = 'fade'
            }

            if ([
                '/pages/main/assist/index',
                '/',
                '/pages/main/bill-order-list/index',
                '/pages/main/order-list/index',
                '/pages/main/my/index'].includes(to.path)) {
                cache.length = 0
                cache.push({ path: to.path })
            }

            localStorage.setItem('routeCache', JSON.stringify(cache))
            if (mode) {
                // 复制内容
                back.innerHTML = app.innerHTML
                // 保持滚动高度
                const warpper = back.querySelector('uni-page-wrapper')
                if (warpper) warpper.style.marginTop = -scrollTop + 'px'
                // 底层退出
                back.classList.add(mode + '-leave')
                // 隐藏内容
                app.style.display = 'none'
            }

        })
        vue.router.afterEach((to, from) => {
            if (mode) {
                // 页面进入
                app.style.display = 'block'
                app.classList.add(mode + '-enter')
                nextTick(() => {
                    const scrollTop = (() => {
                        let scrollTop = 0;
                        try {
                            scrollTop = _get(cache, `${cache.length - 1}.scrollTop`, 0)
                        } catch (e) {
                            scrollTop = 0;
                        }
                        return scrollTop
                    })()
                    const warpper = app.querySelector('uni-page-wrapper')
                    warpper.style.marginTop = -scrollTop + 'px'
                    setTimeout(() => {
                        warpper.style.marginTop = '0'
                        uni.pageScrollTo({ scrollTop, duration: 0 })
                        app.classList.remove(mode + '-enter')
                        back.classList.remove(mode + '-leave')
                        back.innerHTML = ''
                    }, 400);
                })
            }
        })
    })
    // #endif
}

export default routeTransition
